/** Animation duration constants in MS */
export const AnimationDuration = Object.freeze({
  /** A fast animation, such as elements leaving the screen */
  SHORT: 195,
  /** A medium animation, such as elements entering the screen */
  MEDIUM: 225,
  /** A slow animation, such as large, complex, full-screen transitions */
  LONG: 375,
});
